let free = {
  top: {
    title_1: "Reason why we are free",
    explain_1: "When big companies do their web research, they are often misled and blocked by their target"
      + " websites. They are unable to access the Internet like the ordinary people. Those companies pay for your VPN"
      + " service. In exchange, you will allow Rabbit VPN to access the network from your IP address and use the following"
      + " features:",
    title_2: "Rigorous use case review",
    explain_2: "Rabbit VPN uses a manual, rigorous process to scrutinize every company."
      + " Only qualified, respected companies can request the collection of public network data through your device."
      + " Rabbit VPN filters traffic in real time to identify patterns of unethical activity among those companies, and"
      + " will disables them to ensure all companies meet the guidelines."
  },
  download_btn: "Download Rabbit VPN",
  content: {
    brand_protection: {
      title: "Brand Protection",
      desp: "Companies need to collect information about brand infringement in different countries and"
        + " take action against those fake brands. To do this, they need the IP address from different locations to"
        + " visit these sites and gather evidence."
    },
    price_comparison: {
      title: "Price Comparison",
      desp: "The same product is often present different prices depending on the customer’s locating"
        + " country or region. Retailers, travel websites and e-commerce sites all know that price comparisons are key"
        + " to their daily operations. Companies need the IP address to check the prices of products from multiple"
        + " countries to ensure their competitive edge."
    },
    ads_testing: {
      title: "Ads Testing",
      desp: "Companies need to make sure ads are shown correctly at the right time for the right audience"
        + " and that there is no ads fraud. You allow them to view ads in the same way as regular users do."
    },
    web_testing: {
      title: "Web Testing",
      desp: "Most web site content take cares of the location of the users, ensuring that the code, site,"
        + " ads or application embedding in the web are performed as expected. The IP address give them the ability to"
        + " test the site from different locations."
    },
    seo_monitoring: {
      title: "SEO Monitoring",
      desp: "When a user performs a keyword search, the data may vary by country, city, and device. You"
        + " can help them understand the results in different countries/regions."
    },
    market_research: {
      title: "Market Research",
      desp: "The biggest challenges in market research are obtaining accurate data, cleaning the"
        + " misleading data, and even accessing data that is not showing. You can help them get accurate data as a"
        + " regular user."
    }
  }
}
export default free


// WEBPACK FOOTER //
// ./src/assets/lang/en/new_free/index.js